import { render, staticRenderFns } from "./task-square.vue?vue&type=template&id=bfe8165c&"
import script from "./task-square.vue?vue&type=script&lang=js&"
export * from "./task-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports